/**
 * @prettier
 * @flow
 */
import { Environment, type EnvironmentValue } from 'src/constants/Environment';

export const environment: EnvironmentValue = process.env.REACT_APP_ENVIRONMENT ?? Environment.LOCALHOST;
